import Appbase from "appbase-js";
import {
  AppbaseAppUrl,
  AppbaseCustomerApp,
  AppbaseCredentials,
  AppbaseEmployeeApp,
  ReactiveAppConfURL,
  ReactiveAppCredential
} from "../utils/constants";

// export const feedRestrictionsData="";
// export const jewelryHoldRectrictionData="";
export const fetchApiData = async (index, type) => {
  const appbaseRef = Appbase({
    app: index,
    url: ReactiveAppConfURL,
    credentials: ReactiveAppCredential,
  });

  let response = await appbaseRef
    .search({
      body: {
        ...(index === AppbaseEmployeeApp
          ? {
              query: {
                match_all: {},
              },
              size: 10000,
            }
          : {}),
        ...(index === AppbaseCustomerApp
          ? {
              query: {
                match_phrase: {
                  Status: {
                    query: "Active",
                  },
                },
              },
              size: 10000,
            }
          : {}),
        ...(type === "feed"
          ? {
              query: {
                match_phrase: {
                  AttributeID: {
                    query: "KWFEEDS",
                  },
                },
              },
              sort: { SortOrder: { order: "asc" } },
              size: 10000,
              _source: ["Description", "ValueID"],
            }
          : {}),
        ...(type === "jewelry"
          ? {
              query: {
                match_phrase: {
                  AttributeID: {
                    query: "KWHLRSTRCT",
                  },
                },
              },
              sort: { SortOrder: { order: "asc" } },
              size: 10000,
              _source: ["Description", "ValueID"],
            }
          : {}),
      },
    })
    .then(function (res) {
      // console.log("customers results: ", res);
      return res;
    })
    .catch(function (err) {
      console.log("hold notes api data error: ", err);
      // return err;
    });
  if (
    response &&
    response.hits &&
    response.hits.hits &&
    response.hits.hits.length !== 0
  ) {
    return response.hits.hits;
  }
};

// Fetch hold note history from the new raw hold-notes index.
// serialNumber: the serial number (e.g. "FL46271") — or "fetch_All" to get everything.
// app: the Elasticsearch index alias.
// styleNumber: the style number from the catalog document (e.g. "VINTAGE-EARRINGS").
//   Used for client-side filtering since serial numbers are not unique across styles.
export const getHoldNotesData = async (serialNumber, app, styleNumber) => {
  const appbaseRef = Appbase({
    app: app,
    url: ReactiveAppConfURL,
    credentials: ReactiveAppCredential,
  });

  let response = await appbaseRef
    .search({
      body: {
        ...(serialNumber !== "fetch_All"
          ? {
              query: {
                term: {
                  "Serial.keyword": serialNumber,
                },
              },
            }
          : {}),
        ...(serialNumber === "fetch_All"
          ? {
              query: {
                match_all: {},
              },
            }
          : {}),
        size: 10000,
      },
    })
    .then(function (res) {
      // console.log("hold notes results: ", res);
      return res;
    })
    .catch(function (err) {
      console.log("hold notes data error: ", err);
      // return err;
    });
  if (
    response &&
    response.hits &&
    response.hits.hits &&
    response.hits.hits.length !== 0
  ) {
    let hits = response.hits.hits;
    // Client-side filter by style number — serial numbers are not unique across styles.
    // InventoryID in the new index has Acumatica trailing-space padding, so trim before comparing.
    if (serialNumber !== "fetch_All" && styleNumber) {
      hits = hits.filter(
        (hit) =>
          hit._source.InventoryID &&
          hit._source.InventoryID.trim() === String(styleNumber).trim()
      );
    }
    return hits.length > 0 ? hits : undefined;
  }
};
// export const employeeData="";
